import JoditEditor from "../../components/JoditEditor/JoditEditor";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import "rc-pagination/assets/index.css";
import { useEffect, useState } from "react";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import validator from "validator";
import { useAddEventMutation, useGetEventQuery, useUpdateEventMutation, useGetGalleryQuery } from "../../redux/api";
import { Link, useHistory, useParams } from "react-router-dom";
import { ENV } from "config/config";
import GalleryModal from "../../components/Gallery/galleryModal";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
const {
  formatUrl,
  formatUrlManual,
  formatMetaKeywords,
  integerNumberValidator,
  objectToQueryString,
} = ENV;

const UpsertEvent = () => {
  const history = useHistory();
  const { contentId } = useParams();

  const initialImage = {
    default: null,
    home: null,
    category: null,
    related: null,
    search: null,
  };

  const initialData = {
    title: "",
    url: "",
    images: initialImage,
    pageContent: "",
    shortDescription: "",
    location: "",
    eventDate: new Date(), // Default current date
    startTime: new Date(),
    endTime: null,
    metaTitle: "",
    metaKeyword: "",
    metaDescription: "",
    metaDescription: "",
    status: "Published", // Default to Published? User said "Status can be...".
    color: "#ffffff",
    // isActive removed
  };

  const initialMsg = {
    title: "",
    pageContent: "",
    image: "",
    categoryId: "",
    url: "",
    shortDescription: "",
  };

  const [data, setData] = useState(initialData);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [selectedImageType, setSelectedImageType] = useState("default");
  const [imageView, setImageView] = useState(initialImage);
  const [msg, setMsg] = useState(initialMsg);
  const [id, setId] = useState("");
  const [selectCategories, setSelectCategories] = useState([]);
  
  const [isOpenModal, setOpenModal] = useState(false);
  const [gallery, setGallery] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [filters, setFilters] = useState({
    name: "",
  });

  const [resetButton, setResetButton] = useState(false);

  useEffect(() => {
    window.scroll(0, 0);
    if (contentId) {
      setId(contentId);
    }
  }, [contentId]);
  const { data: eventRes, isLoading: isEventLoading, isFetching: isEventFetching } = useGetEventQuery(id ? window.atob(id) : undefined, { skip: !id });
  const [addEvent, { isLoading: isAddingEvent }] = useAddEventMutation();
  const [updateEvent, { isLoading: isUpdatingEvent }] = useUpdateEventMutation();

  useEffect(() => {}, []);

  useEffect(() => {
    if (eventRes) {
      const { EntityImages, ...rest } = eventRes;
      const images = {};
      const ImageView = {};
      if (EntityImages && EntityImages.forEach) {
        EntityImages.forEach((item) => {
          images[item.page] = item.imageId;
          ImageView[item.page] = item.Gallery.image;
        });
      }
      const newEventRes = {
        ...rest,
        images,
        eventDate: rest.eventDate ? new Date(rest.eventDate) : new Date(),
        startTime: rest.startTime ? moment(rest.startTime, "HH:mm:ss").toDate() : new Date(),
        endTime: rest.endTime ? moment(rest.endTime, "HH:mm:ss").toDate() : null,
      };
      setImageView(ImageView);
      setData(newEventRes);
      setIsDataLoaded(true);
    }
  }, [eventRes]);

  useEffect(() => {}, []);

  useEffect(() => {}, []);

  const [galleryQs, setGalleryQs] = useState("");
  const { data: galleryRes, isLoading: isGalleryLoading, isFetching: isGalleryFetching } = useGetGalleryQuery(galleryQs, { skip: !galleryQs });
  const isGlobalLoading = isEventLoading || isGalleryLoading || isAddingEvent || isUpdatingEvent || (id && !isDataLoaded);
  useEffect(() => {
    if (galleryRes && galleryRes.gallery) {
      setGallery(galleryRes.gallery);
      setPagination(galleryRes.pagination);
    }
  }, [galleryRes]);

  const VALIDATION_ERROR_MESSAGES = {
    title: "Title field is Required.",
    pageContent: "Page Content field is Required.",
    image: "Image field is Required.",
    url: "Url field is Required.",
    shortDescription: "Short Description field is Required.",
    eventDate: "Event Date is Required.",
    startTime: "Start Time is Required.",
  };

  const validateField = (value, validator, errorMessage, field) => {
    if (validator(value)) {
      setMsg((prevErrors) => ({ ...prevErrors, [field]: errorMessage }));
      return false;
    } else {
      setMsg((prevErrors) => ({ ...prevErrors, [field]: "" }));
      return true;
    }
  };

  const submit = () => {
    let isValid = true;
    isValid &= validateField(
      data.title,
      validator.isEmpty,
      VALIDATION_ERROR_MESSAGES.title,
      "title"
    );
    isValid &= validateField(
      data.pageContent,
      validator.isEmpty,
      VALIDATION_ERROR_MESSAGES.pageContent,
      "pageContent"
    );
    isValid &= validateField(
      String(data.images.default ?? ""),
      validator.isEmpty,
      VALIDATION_ERROR_MESSAGES.image,
      "image"
    );
    isValid &= validateField(
      String(data.eventDate),
      validator.isEmpty,
      VALIDATION_ERROR_MESSAGES.eventDate,
      "eventDate"
    );
    isValid &= validateField(
      data.startTime ? String(data.startTime) : "",
      validator.isEmpty,
      VALIDATION_ERROR_MESSAGES.startTime,
      "startTime"
    );
    isValid &= validateField(
      data.url,
      validator.isEmpty,
      VALIDATION_ERROR_MESSAGES.url,
      "url"
    );
    isValid &= validateField(
      data.shortDescription,
      validator.isEmpty,
      VALIDATION_ERROR_MESSAGES.shortDescription,
      "shortDescription"
    );

    if (isValid) {
      const payload = {
        ...data,
        startTime: data.startTime ? moment(data.startTime).format("HH:mm:ss") : "00:00:00",
        endTime: data.endTime ? moment(data.endTime).format("HH:mm:ss") : null,
      };
      if (id) {
        updateEvent(payload).then((res) => {
          if (!res.error) {
            history.push("/events");
          }
        });
      } else {
        addEvent(payload).then((res) => {
          if (!res.error) {
            history.push("/events");
          }
        });
      }
    }
  };



  const setImage = (img) => {
    setData((prevData) => {
      const { Gallery, ...rest } = prevData;

      // Update the image for the selected type
      const updatedImages = {
        ...prevData.images, // Keep existing images
        [selectedImageType]: img.id, // Update the selected type
      };

      return { ...rest, images: updatedImages };
    });

    setImageView((prevViews) => ({
      ...prevViews,
      [selectedImageType]: img.image, // Update the preview for the selected type
    }));

    setMsg((prevErrors) => ({ ...prevErrors, image: "" }));
  };

  const fetchGallery = () => {
    const qs = objectToQueryString({ page: 1, limit: 12, isActive: true });
    setGalleryQs(qs);
    setOpenModal(true);
  };

  const onPageChange = async (page) => {
    const qs = objectToQueryString({ page, ...filters });
    setGalleryQs(qs);
  };

  const reset = () => {
    setResetButton(false);
    setFilters({ name: "" });
    setGalleryQs("");
  };

  const applyFilters = () => {
    if (filters && filters.name) {
      setResetButton(true);
      const qs = objectToQueryString({ page: 1, limit: 10, ...filters });
      setGalleryQs(qs);
    } else {
      toast.error("Search fields are empty.", {
        toastId: "FIELD_REQUIRED",
      });
    }
  };



  if (isGlobalLoading) {
    return <FullPageLoader />;
  }

  return (
    <>
      <Container>
          <Row>
            <Col md="12">
              <Card className="pb-3 table-big-boy">
                <Card.Header>
                  <Card.Title as="h4">{id ? "Edit " : "Add "} Event</Card.Title>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label>
                          Title<span className="text-danger"> *</span>
                        </label>
                        <Form.Control
                          className={msg.title ? `on-error` : ``}
                          value={data.title ? data.title : ""}
                          onChange={(e) => {
                            const newName = e.target.value;
                            const newUrl = formatUrl(newName);
                            setData({
                              ...data,
                              title: newName,
                              url: newUrl,
                              metaTitle: newName,
                              metaKeyword: formatMetaKeywords(newUrl),
                            });
                            setMsg((prevErrors) => ({
                              ...prevErrors,
                              title: "",
                              url: "",
                            }));
                          }}
                          placeholder="Title"
                          type="text"
                        ></Form.Control>
                        <span className={msg.title ? `` : `d-none`}>
                          <label className="pl-1 text-danger">
                            {msg.title}
                          </label>
                        </span>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label className="">
                          URL<span className="text-danger">*</span>
                        </label>
                        <Form.Control
                          className={msg.url ? `on-error` : ``}
                          placeholder="Enter url"
                          type="text"
                          name="url"
                          onChange={(e) => {
                            setData({
                              ...data,
                              url: formatUrlManual(e.target.value),
                            });
                            setMsg((prevErrors) => ({
                              ...prevErrors,
                              url: "",
                            }));
                          }}
                          value={data?.url}
                          required
                        />
                        <span className={msg.url !== "" ? `` : `d-none`}>
                          <label className="pl-1 text-danger">{msg.url}</label>
                        </span>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label className="">Location</label>
                        <Form.Control
                          placeholder="Enter location"
                          type="text"
                          name="location"
                          onChange={(e) => {
                            setData({ ...data, location: e.target.value });
                          }}
                          value={data?.location}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="4">
                      <Form.Group>
                        <label>Status</label>
                        <Form.Control
                          as="select"
                          value={data.status}
                          onChange={(e) => setData({ ...data, status: e.target.value })}
                        >
                          <option value="Draft">Draft</option>
                          <option value="Published">Published</option>
                          <option value="Inactive">Inactive</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                     <Col md="4">
                       <Form.Group>
                        <label>Color</label>
                        <Form.Control
                          type="color"
                          value={data.color || "#ffffff"}
                          onChange={(e) => setData({ ...data, color: e.target.value })}
                        />
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group>
                        <label className="">
                          Event Date<span className="text-danger">*</span>
                        </label>
                        <div>
                          <DatePicker
                            selected={data.eventDate}
                            onChange={(date) =>
                              setData({ ...data, eventDate: date })
                            }
                            className={msg.eventDate ? `on-error form-control` : `form-control`}
                            placeholderText="Select Event Date"
                            name="eventDate"
                            required
                          />
                        </div>
                        <span className={msg.eventDate !== "" ? `` : `d-none`}>
                          <label className="pl-1 text-danger">
                            {msg.eventDate}
                          </label>
                        </span>
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group>
                        <label className="">
                          Start Time<span className="text-danger">*</span>
                        </label>
                        <div>
                          <DatePicker
                            selected={data.startTime}
                            onChange={(date) =>
                              setData({ ...data, startTime: date })
                            }
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15}
                            timeCaption="Time"
                            dateFormat="h:mm aa"
                            className={msg.startTime ? `on-error form-control` : `form-control`}
                            placeholderText="Select Start Time"
                            name="startTime"
                            required
                          />
                        </div>
                        <span className={msg.startTime !== "" ? `` : `d-none`}>
                          <label className="pl-1 text-danger">
                            {msg.startTime}
                          </label>
                        </span>
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group>
                        <label className="">
                          End Time
                        </label>
                        <div>
                          <DatePicker
                            selected={data.endTime}
                            onChange={(date) =>
                              setData({ ...data, endTime: date })
                            }
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15}
                            timeCaption="Time"
                            dateFormat="h:mm aa"
                            className="form-control"
                            placeholderText="Select End Time"
                            name="endTime"
                          />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label className="">
                          Image<span className="text-danger">*</span>
                        </label>
                        <div className="d-flex align-items-center">
                          <Button
                            className="btn-filled pull-right mt-3"
                            variant="info"
                            onClick={fetchGallery}
                          >
                            Choose Image
                          </Button>
                          <Form.Control
                            as="select"
                            className="image-select"
                            value={selectedImageType}
                            onChange={(e) =>
                              setSelectedImageType(e.target.value)
                            }
                          >
                            <option value="default">Default</option>
                            <option value="home">Home</option>
                            <option value="category">Listing Page</option>
                            <option value="related">Related</option>
                            <option value="search">Search</option>
                          </Form.Control>
                        </div>
                      </Form.Group>
                      <span className={msg.image !== "" ? `` : `d-none`}>
                        <label className="pl-1 text-danger">{msg.image}</label>
                      </span>
                      {imageView &&
                        Object.entries(imageView || {}).map(([type, image]) => (
                          <Form.Group key={type}>
                            <label>
                              {type.charAt(0).toUpperCase() + type.slice(1)}:
                            </label>
                            {image ? (
                              <img
                                src={`${ENV.assetsUrl}gallery/${image}`}
                                id={`imageUploader-${type}`}
                                className="image-fluid"
                                style={{ width: "30%", height: "30%" }}
                                alt={`${type}-gallery-image`}
                              />
                            ) : (
                              <span>No image selected</span>
                            )}
                          </Form.Group>
                        ))}
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12" sm="6">
                      <label>
                        Text / Description
                        <span className="text-danger"> *</span>
                      </label>
                      <JoditEditor
                        value={data.pageContent || ""}
                        onChange={(content) => {
                          setData({ ...data, pageContent: content });
                          setMsg({ ...msg, pageContent: "" });
                        }}
                      />
                      <span className={msg.pageContent ? `` : `d-none`}>
                        <label className="pl-1 text-danger">
                            {msg.pageContent}
                        </label>
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label className="">
                          Short Description
                          <span className="text-danger"> *</span>
                        </label>
                        <Form.Control
                          as="textarea"
                          rows={5}
                          className={msg.shortDescription ? `on-error` : ``}
                          placeholder="Enter short description"
                          type="text"
                          name="shortDescription"
                          onChange={(e) => {
                            setData({
                              ...data,
                              shortDescription: e.target.value,
                            });
                            setMsg({ ...msg, shortDescription: "" });
                          }}
                          value={data?.shortDescription}
                          required
                        />
                        <span className={msg.shortDescription ? `` : `d-none`}>
                          <label className="pl-1 text-danger">
                            {msg.shortDescription}
                          </label>
                        </span>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label className="">Meta Title</label>
                        <Form.Control
                          placeholder="Enter Meta tiltes"
                          type="text"
                          name="metaTitle"
                          onChange={(e) =>
                            setData({ ...data, metaTitle: e.target.value })
                          }
                          value={data?.metaTitle}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label className="">Meta Keywords</label>
                        <Form.Control
                          placeholder="Enter Meta Keywords"
                          type="text"
                          name="metaKeyword"
                          onChange={(e) =>
                            setData({ ...data, metaKeyword: e.target.value })
                          }
                          value={data?.metaKeyword}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label className="">Meta Description</label>
                        <Form.Control
                          placeholder="Enter Meta Description"
                          type="text"
                          name="metaDescription"
                          onChange={(e) =>
                            setData({
                              ...data,
                              metaDescription: e.target.value,
                            })
                          }
                          value={data?.metaDescription}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12" sm="6">
                      <div className="d-flex justify-content-end align-items-center">
                        <div className="mr-2">
                          <Link
                            to={"/events"}
                            className="outline-button btn btn-primary mt-3"
                          >
                            Back
                          </Link>
                        </div>
                        <Button
                          className="btn-filled pull-right mt-3"
                          type="submit"
                          variant="info"
                          onClick={submit}
                        >
                          {id ? "Update " : "Add "}
                        </Button>
                      </div>
                    </Col>
                  </Row>

                </Card.Body>
              </Card>
            </Col>
          </Row>
          <GalleryModal
            isOpenModal={isOpenModal}
            setOpenModal={setOpenModal}
            setImage={setImage}
            gallery={gallery}
            pagination={pagination}
            onPageChange={onPageChange}
            reset={reset}
            applyFilters={applyFilters}
            filters={filters}
            setFilters={setFilters}
            resetButton={resetButton}
          />
        </Container>
    </>
  );
};

export default UpsertEvent;
